const DRIVER_LINK_STYLE = "cursor-pointer text-stone-600 dark:text-stone-400";

export const guidedTourLink = (href: string, text: string, asText = true) => {
  return asText ? (
    `<a
      class=${DRIVER_LINK_STYLE}
      href=${href}
      target="_blank"
      rel="noreferrer"
    >
      ${text}</a>`
  ) : (
    <a
      className={DRIVER_LINK_STYLE}
      href={href}
      target="_blank"
      rel="noreferrer"
    >
      {text}
    </a>
  );
};
